(function () {
  "use strict";

  var VS = [
    "attribute vec3 p; attribute vec2 uv; attribute vec3 nrm; attribute float face;",
    "uniform mat3 rotation; uniform mat3 eclairage; uniform mediump float ratio; uniform float epaisseur;",
    "uniform mediump float distance; uniform vec2 champ;",
    "varying vec2 vUv; varying vec3 vN; varying vec3 vP; varying float vFace;",
    "void main(){",
    "  vec3 point = vec3(p.x * ratio, p.y, (p.z - 0.5) * epaisseur);",
    "  vP = eclairage * point; vN = eclairage * nrm; vUv = uv; vFace = face;",
    "  vec3 position = rotation * point;",
    "  float z = distance - position.z;",
    "  gl_Position = vec4(position.xy * (2.0 * distance) / champ, z - 0.2, z);",
    "}",
  ].join("\n");

  var FS = [
    "precision mediump float;",
    "varying vec2 vUv; varying vec3 vN; varying vec3 vP; varying float vFace;",
    "uniform sampler2D image; uniform float distance; uniform float ratio;",
    "uniform float ratioImage; uniform float metal; uniform float accrochee;",
    "uniform vec2 part; uniform vec3 fond;",
    "vec3 lineaire(vec3 c){",
    "  return mix(c / 12.92, pow((c + 0.055) / 1.055, vec3(2.4)), step(vec3(0.04045), c));",
    "}",
    "vec3 ecran(vec3 c){",
    "  return mix(c * 12.92, 1.055 * pow(max(c, vec3(0.0)), vec3(1.0 / 2.4)) - 0.055, step(vec3(0.0031308), c));",
    "}",
    "float rectangle(vec2 point, vec2 centre, vec2 demiCote, float douceur){",
    "  vec2 ecart = abs(point - centre) - demiCote;",
    "  return 1.0 - smoothstep(-douceur, douceur, max(ecart.x, ecart.y));",
    "}",
    "void main(){",
    "  vec3 N = normalize(vN);",
    "  vec3 V = normalize(vec3(0.0, 0.0, distance) - vP);",
    "  vec3 R = reflect(-V, N);",
    "  if (vFace > 0.5){",
    "    vec3 L = normalize(vec3(-0.8, 1.4, 2.4) - vP);",
    "    float lumiere = 0.22 + 0.48 * max(dot(N, L), 0.0);",
    "    float reflet = pow(max(dot(N, normalize(L + V)), 0.0), 38.0);",
    "    gl_FragColor = vec4(vec3(0.78, 0.80, 0.82) * lumiere + reflet * 0.3, 1.0);",
    "    return;",
    "  }",
    "  vec2 z = (vUv - 0.5) / part + 0.5;",
    "  bool marge = z.x < 0.0 || z.x > 1.0 || z.y < 0.0 || z.y > 1.0;",
    "  float zone = ratio * part.x / part.y;",
    "  vec2 uvImage = z;",
    "  if (zone > ratioImage) uvImage.y = (z.y - 0.5) * ratioImage / zone + 0.5;",
    "  else uvImage.x = (z.x - 0.5) * zone / ratioImage + 0.5;",
    "  vec3 base = marge ? fond : texture2D(image, uvImage).rgb;",
    "  float t = max(0.0, (2.4 - vP.z) / max(R.z, 0.05));",
    "  vec2 piece = (vP + R * t).xy;",
    // Adrien préfère le vernis diffus : source douce et intensité modérée,
    // pour garder l'œuvre lisible pendant toute la rotation.
    "  float fenetre = rectangle(piece, vec2(-0.62, 0.58), vec2(0.34, 0.82), 0.16);",
    "  float retour = rectangle(piece, vec2(1.15, -0.12), vec2(0.09, 1.25), 0.18);",
    "  float fresnel = 0.045 + 0.955 * pow(1.0 - max(dot(N, V), 0.0), 5.0);",
    "  float vernis = metal * (marge ? 0.0 : 1.0) * min(fresnel, 0.22) * mix(1.0, 0.72, accrochee);",
    "  float devant = step(0.01, R.z);",
    "  float lumiere = clamp(fenetre + retour * 0.24, 0.0, 1.0) * devant;",
    "  vec3 couleur = mix(lineaire(base), vec3(1.35, 1.36, 1.38), vernis * lumiere);",
    "  gl_FragColor = vec4(clamp(ecran(couleur), 0.0, 1.0), 1.0);",
    "}",
  ].join("\n");

  function geometrique() {
    var positions = [], normales = [], uvs = [], faces = [], indices = [];
    function face(a, b, c, d, normale, avant) {
      var offset = positions.length / 3;
      [a, b, c, d].forEach(function (point) {
        positions.push.apply(positions, point);
        normales.push.apply(normales, normale);
        faces.push(avant ? 0 : 1);
      });
      uvs.push(0, 1, 1, 1, 1, 0, 0, 0);
      indices.push(offset, offset + 1, offset + 2, offset, offset + 2, offset + 3);
    }
    var x = 0.5, y = 0.5, z = 0.5;
    face([-x,y,z], [x,y,z], [x,-y,z], [-x,-y,z], [0,0,1], true);
    face([x,y,-z], [-x,y,-z], [-x,-y,-z], [x,-y,-z], [0,0,-1], false);
    face([-x,y,-z], [-x,y,z], [-x,-y,z], [-x,-y,-z], [-1,0,0], false);
    face([x,y,z], [x,y,-z], [x,-y,-z], [x,-y,z], [1,0,0], false);
    face([-x,y,-z], [x,y,-z], [x,y,z], [-x,y,z], [0,1,0], false);
    face([-x,-y,z], [x,-y,z], [x,-y,-z], [-x,-y,-z], [0,-1,0], false);
    return { p: positions, nrm: normales, uv: uvs, face: faces, indices: indices };
  }

  function rotation(rx, ry) {
    var cx = Math.cos(rx), sx = Math.sin(rx), cy = Math.cos(ry), sy = Math.sin(ry);
    return new Float32Array([cy, sx * sy, -cx * sy, 0, cx, sx, sy, -sx * cy, cx * cy]);
  }

  function hexVersRvb(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h.split('').map(function (x) { return x + x; }).join('');
    if (!/^[0-9a-f]{6}$/i.test(h)) return [1, 1, 1];
    return [0, 2, 4].map(function (i) { return parseInt(h.slice(i, i + 2), 16) / 255; });
  }

  function encombrement(rapport, rx, ry, distance, epaisseur) {
    var largeur = 0, hauteur = 0;
    var cx = Math.cos(rx), sx = Math.sin(rx), cy = Math.cos(ry), sy = Math.sin(ry);
    // Mesurer les huit coins dans la pose actuelle, comme le vertex shader.
    // Réserver toute la course dès l'ouverture réduisait le paysage de près de moitié.
    [-1, 1].forEach(function (coteX) {
      [-1, 1].forEach(function (coteY) {
        [-1, 1].forEach(function (coteZ) {
          var x = coteX * rapport / 2, y = coteY / 2, z = coteZ * epaisseur / 2;
          var px = cy * x + sy * z;
          var py = sx * sy * x + cx * y - sx * cy * z;
          var pz = -cx * sy * x + sx * y + cx * cy * z;
          largeur = Math.max(largeur, Math.abs(px) * distance / (distance - pz));
          hauteur = Math.max(hauteur, Math.abs(py) * distance / (distance - pz));
        });
      });
    });
    return { largeur: largeur * 2, hauteur: hauteur * 2 };
  }

  window.__displateMonter = function (toile, urlImage, rapport, options) {
    var exploration = !!(options && options.exploration);
    var surface = !!(options && options.surface);
    var lumiereSurface = rotation(0, 0), surfaceAccrochee = false;
    var interaction = !exploration && toile.parentElement && toile.parentElement.addEventListener ? toile.parentElement : toile;
    var gl;
    try { gl = toile.getContext('webgl', { antialias: true, alpha: true, premultipliedAlpha: true }); }
    catch (_) { return null; }
    if (!gl) return null;

    var ressources = [], prog, texture, uniforms;
    var pret = false, perdu = false, detruit = false, chargee = false;
    var image = new Image();
    var donnees = geometrique();
    var mouvement = window.matchMedia('(prefers-reduced-motion: reduce)');
    var calme = mouvement.matches, interactif = !surface, visible = true, metal = true;
    var rx = 0, ry = 0, cibleX = 0, cibleY = 0, raf = 0, precedent = 0;
    var part = [1, 1], fond = [1, 1, 1], hauteurMm = 400;
    var dernierEtat = false;
    var DISTANCE = 3.8;
    var MAX_X = exploration ? 0.96 : 0.24, MAX_Y = exploration ? 1.31 : 0.38;
    var prise = null;
    var automatique = false, survole = false, phase = 0;

    function animeAuRepos() {
      return automatique && metal && interactif && !calme && !survole;
    }

    function etat(valeur) {
      pret = valeur;
      toile.dataset.metalReady = String(valeur);
      if (dernierEtat === valeur) return;
      dernierEtat = valeur;
      toile.dispatchEvent(new CustomEvent('af:metal-ready', { bubbles: true, detail: { ready: valeur } }));
    }

    function nettoyer() {
      ressources.forEach(function (r) { gl[r[0]](r[1]); });
      ressources = [];
    }

    function shader(type, texte) {
      var s = gl.createShader(type);
      ressources.push(['deleteShader', s]);
      gl.shaderSource(s, texte); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s));
      return s;
    }

    function televerser() {
      if (!chargee || perdu || detruit) return;
      try {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        var maximum = gl.getParameter(gl.MAX_TEXTURE_SIZE);
        var source = image;
        if (Math.max(image.naturalWidth, image.naturalHeight) > maximum) {
          source = document.createElement('canvas');
          var k = maximum / Math.max(image.naturalWidth, image.naturalHeight);
          source.width = Math.max(1, Math.floor(image.naturalWidth * k));
          source.height = Math.max(1, Math.floor(image.naturalHeight * k));
          source.getContext('2d').drawImage(image, 0, 0, source.width, source.height);
        }
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        if (gl.getError() !== gl.NO_ERROR) throw new Error('texture');
        etat(true);
        demander();
      } catch (_) { etat(false); toile.dispatchEvent(new CustomEvent('af:metal-error')); }
    }

    function initialiser() {
      try {
        prog = gl.createProgram();
        ressources.push(['deleteProgram', prog]);
        gl.attachShader(prog, shader(gl.VERTEX_SHADER, VS));
        gl.attachShader(prog, shader(gl.FRAGMENT_SHADER, FS));
        gl.linkProgram(prog);
        if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(prog));
        gl.useProgram(prog);
        [['p',3], ['nrm',3], ['uv',2], ['face',1]].forEach(function (attribut) {
          var tampon = gl.createBuffer();
          ressources.push(['deleteBuffer', tampon]);
          gl.bindBuffer(gl.ARRAY_BUFFER, tampon);
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(donnees[attribut[0]]), gl.STATIC_DRAW);
          var position = gl.getAttribLocation(prog, attribut[0]);
          gl.enableVertexAttribArray(position);
          gl.vertexAttribPointer(position, attribut[1], gl.FLOAT, false, 0, 0);
        });
        var index = gl.createBuffer();
        ressources.push(['deleteBuffer', index]);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, index);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(donnees.indices), gl.STATIC_DRAW);
        texture = gl.createTexture();
        ressources.push(['deleteTexture', texture]);
        uniforms = {};
        ['rotation','eclairage','ratio','epaisseur','distance','champ','image','ratioImage','metal','accrochee','part','fond'].forEach(function (nom) {
          uniforms[nom] = gl.getUniformLocation(prog, nom);
        });
        gl.enable(gl.DEPTH_TEST);
        gl.clearColor(0,0,0,0);
        televerser();
        return true;
      } catch (e) {
        console.warn('[displate] aperçu indisponible', e.message);
        nettoyer();
        etat(false);
        return false;
      }
    }

    if (!initialiser()) return null;

    function dessiner() {
      if (!pret || perdu || detruit || !visible || document.hidden) return;
      var hote = toile.parentElement && toile.parentElement.parentElement;
      var largeur = !surface && hote ? hote.clientWidth : toile.clientWidth;
      var hauteur = !surface && hote ? hote.clientHeight : toile.clientHeight;
      if (!largeur || !hauteur || !toile.clientWidth || !toile.clientHeight) return;
      var ratioObjet = exploration || surface ? rapport : largeur / hauteur;
      var epaisseur = surface ? 0 : 2 / hauteurMm;
      var hauteurObjet = hauteur;
      if (exploration) {
        var cadre = encombrement(rapport, rx, ry, DISTANCE, epaisseur);
        // Grande à l'ouverture, sans grossir lorsqu'elle se tourne de profil.
        // Le recul intervient seulement si les coins approchent du bord, en suivant
        // la rotation déjà amortie : aucune coupe ni saut entre deux angles.
        hauteurObjet = Math.min(hauteur * 0.88, largeur * 0.90 / rapport,
          hauteur * 0.92 / cadre.hauteur, largeur * 0.94 / cadre.largeur);
      }
      var densite = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.max(1, Math.round(toile.clientWidth * densite));
      var h = Math.max(1, Math.round(toile.clientHeight * densite));
      if (toile.width !== w || toile.height !== h) { toile.width = w; toile.height = h; }
      gl.viewport(0, 0, w, h);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      gl.useProgram(prog);
      var orientation = rotation(rx, ry);
      gl.uniformMatrix3fv(uniforms.rotation, false, surface ? rotation(0, 0) : orientation);
      gl.uniformMatrix3fv(uniforms.eclairage, false, surface ? lumiereSurface : orientation);
      gl.uniform1f(uniforms.ratio, ratioObjet);
      gl.uniform1f(uniforms.epaisseur, epaisseur);
      gl.uniform1f(uniforms.distance, DISTANCE);
      gl.uniform2f(uniforms.champ, surface ? rapport : toile.clientWidth / hauteurObjet, surface ? 1 : toile.clientHeight / hauteurObjet);
      gl.uniform1i(uniforms.image, 0);
      gl.uniform1f(uniforms.ratioImage, rapport || image.naturalWidth / image.naturalHeight);
      gl.uniform1f(uniforms.metal, metal ? 1 : 0);
      gl.uniform1f(uniforms.accrochee, surface ? (surfaceAccrochee ? 1 : 0) : (interactif ? 0 : 1));
      gl.uniform2f(uniforms.part, part[0], part[1]);
      gl.uniform3f(uniforms.fond, fond[0], fond[1], fond[2]);
      gl.drawElements(gl.TRIANGLES, surface ? 6 : donnees.indices.length, gl.UNSIGNED_SHORT, 0);
    }

    function frame(temps) {
      raf = 0;
      if (!pret || detruit || perdu || !visible || document.hidden) { precedent = 0; return; }
      var dt = precedent ? Math.min(64, temps - precedent) : 16;
      precedent = temps;
      var anime = animeAuRepos();
      if (anime) {
        phase += dt * Math.PI * 2 / 9000;
        cibleX = Math.sin(phase * 2) * 0.065;
        cibleY = Math.sin(phase) * 0.24;
      }
      var k = 1 - Math.exp(-dt / 85);
      rx += (cibleX - rx) * k; ry += (cibleY - ry) * k;
      var bouge = Math.abs(cibleX - rx) + Math.abs(cibleY - ry) > 0.0001;
      if (!bouge) { rx = cibleX; ry = cibleY; if (!anime) precedent = 0; }
      dessiner();
      if (bouge || anime) demander();
    }

    function demander() {
      if (!raf && !detruit && !perdu && visible && !document.hidden) raf = requestAnimationFrame(frame);
    }

    function viser(x, y) {
      if ((calme && !exploration) || !interactif) return;
      cibleX = Math.max(-MAX_X, Math.min(MAX_X, x));
      cibleY = Math.max(-MAX_Y, Math.min(MAX_Y, y));
      if (calme) { rx = cibleX; ry = cibleY; }
      demander();
    }

    function surPointeur(e) {
      if (!interactif || !pret) return;
      if (exploration) {
        if (!prise || prise.id !== e.pointerId) return;
        var cote = Math.max(180, Math.min(toile.clientWidth, toile.clientHeight));
        viser(prise.rx - (e.clientY - prise.y) * 3.2 / cote,
          prise.ry + (e.clientX - prise.x) * 3.8 / cote);
        return;
      }
      // Dans la fiche, le doigt garde le défilement et le carrousel. La manipulation
      // sur deux axes est explicite dans la vue agrandie, sans concurrence de gestes.
      if (calme || e.pointerType === 'touch') return;
      survole = true;
      var r = interaction.getBoundingClientRect();
      var u = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      var v = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
      viser((v - 0.5) * -MAX_X * 2, (u - 0.5) * MAX_Y * 2);
    }

    function prendre(e) {
      if (!exploration) { surPointeur(e); return; }
      if (!pret || !interactif || prise || e.isPrimary === false || (e.button && e.button !== 0)) return;
      prise = { id: e.pointerId, x: e.clientX, y: e.clientY, rx: cibleX, ry: cibleY };
      if (toile.setPointerCapture) toile.setPointerCapture(e.pointerId);
      toile.dataset.dragging = 'true';
    }
    function lacher(e) {
      if (prise && e && e.pointerId !== prise.id) return;
      if (prise && toile.hasPointerCapture && toile.hasPointerCapture(prise.id)) toile.releasePointerCapture(prise.id);
      prise = null; toile.dataset.dragging = 'false';
      if (!exploration) repos();
    }
    function sortir() { if (!exploration) { survole = false; phase = 0; repos(); } }
    function repos() { cibleX = 0; cibleY = 0; if (calme) rx = ry = 0; demander(); }
    function clavier(e) {
      if (!exploration || !interactif) return;
      var dx = { ArrowUp: 0.16, ArrowDown: -0.16 }, dy = { ArrowLeft: -0.20, ArrowRight: 0.20 };
      if (e.key === 'Home') { e.preventDefault(); repos(); }
      else if (e.key in dx || e.key in dy) { e.preventDefault(); viser(cibleX + (dx[e.key] || 0), cibleY + (dy[e.key] || 0)); }
    }
    function preference() { calme = mouvement.matches; rx = ry = cibleX = cibleY = 0; demander(); }
    function visibilite() {
      if (document.hidden) { cancelAnimationFrame(raf); raf = 0; precedent = 0; }
      else demander();
    }
    function contextePerdu(e) {
      e.preventDefault(); lacher(); perdu = true; cancelAnimationFrame(raf); raf = 0; ressources = [];
      etat(false);
    }
    function contexteRetabli() { perdu = false; initialiser(); }

    interaction.addEventListener('pointermove', surPointeur);
    interaction.addEventListener('pointerdown', prendre);
    interaction.addEventListener('pointerleave', sortir);
    interaction.addEventListener('pointerup', lacher);
    interaction.addEventListener('pointercancel', lacher);
    interaction.addEventListener('lostpointercapture', lacher);
    toile.addEventListener('keydown', clavier);
    toile.addEventListener('webglcontextlost', contextePerdu);
    toile.addEventListener('webglcontextrestored', contexteRetabli);
    document.addEventListener('visibilitychange', visibilite);
    if (mouvement.addEventListener) mouvement.addEventListener('change', preference);
    var ro = window.ResizeObserver ? new ResizeObserver(demander) : null;
    if (ro) ro.observe(toile);
    else window.addEventListener('resize', demander);
    var io = window.IntersectionObserver ? new IntersectionObserver(function (entrees) {
      // L'image prête peut masquer puis révéler la toile dans la même trame.
      // L'observateur livre alors plusieurs états : seul le plus récent fait foi.
      visible = entrees[entrees.length - 1].isIntersecting;
      if (visible) demander();
      else { cancelAnimationFrame(raf); raf = 0; precedent = 0; }
    }) : null;
    if (io) io.observe(surface && options.visibilite ? options.visibilite : toile);
    image.crossOrigin = 'anonymous';
    image.onload = function () { chargee = true; televerser(); };
    image.onerror = function () { etat(false); toile.dispatchEvent(new CustomEvent('af:metal-error')); };
    etat(false);
    image.src = urlImage;

    return {
      ready: function () { return pret; },
      automatique: function (oui) {
        var active = !!oui && !exploration && !surface;
        if (automatique === active) return;
        automatique = active; survole = false; phase = 0;
        repos();
      },
      eclairer: function (matrice, accrochee) {
        if (!surface) return;
        lumiereSurface = new Float32Array(matrice);
        surfaceAccrochee = !!accrochee;
        demander();
      },
      support: function (oui) { metal = !!oui; demander(); },
      geste: function (oui) {
        interactif = !!oui;
        toile.dataset.metalInteractive = String(interactif);
        if (!oui) rx = ry = cibleX = cibleY = 0;
        demander();
      },
      incliner: function (x, y) {
        if ((!calme || exploration) && interactif) { rx = cibleX = Math.max(-MAX_X, Math.min(MAX_X, x)); ry = cibleY = Math.max(-MAX_Y, Math.min(MAX_Y, y)); }
        dessiner(); demander();
      },
      tourner: function (x, y) { viser(cibleX + x, cibleY + y); },
      recentrer: repos,
      pose: function () { return { x: cibleX, y: cibleY }; },
      format: function (hauteur) {
        if (hauteur > 0) hauteurMm = hauteur;
        demander();
      },
      bordure: function (largeur, hauteur, hex) {
        part = [largeur > 0 ? largeur : 1, hauteur > 0 ? hauteur : 1];
        fond = hexVersRvb(hex); demander();
      },
      destroy: function () {
        detruit = true; cancelAnimationFrame(raf);
        if (ro) ro.disconnect(); if (io) io.disconnect();
        window.removeEventListener('resize', demander);
        document.removeEventListener('visibilitychange', visibilite);
        if (mouvement.removeEventListener) mouvement.removeEventListener('change', preference);
        interaction.removeEventListener('pointermove', surPointeur);
        interaction.removeEventListener('pointerdown', prendre);
        interaction.removeEventListener('pointerleave', sortir);
        ['pointerup','pointercancel','lostpointercapture'].forEach(function (nom) { interaction.removeEventListener(nom, lacher); });
        toile.removeEventListener('keydown', clavier);
        toile.removeEventListener('webglcontextlost', contextePerdu);
        toile.removeEventListener('webglcontextrestored', contexteRetabli);
        image.onload = image.onerror = null;
        if (!perdu) nettoyer();
        etat(false);
      },
    };
  };
})();
